import * as types from './types';

const initState = {};


export default (state = initState, action) => {
  switch (action.type) {
    case types.SET_CATEGORIES: {
      return action.categories;
    }
    default: return state;
  }
};
